const SystemRoot = {
  id: 'system',
  url: '/system',
};

const SystemRaSearch = {
  id: 'systemra-search',
  url: '/system/ra-search',
};

const SystemScan = {
  id: 'systemscan',
  url: '/system/scan',
};

const SystemCrlv = {
  id: 'systemcrlv',
  url: '/system/crlv',
};

const SystemSublocacao = {
  id: 'systemsublocacao',
  url: '/system/sublocacao',
}

const SystemSublocacaoRelatorio = {
  id: 'systemsublocacao-relatorio',
  url: '/system/sublocacao-relatorio',
}

const SystemUploadPaymentProof = {
  id: 'systemupload-comprovante-pagamento',
  url: '/system/upload-comprovante-pagamento',
}

const SystemUberDocument = {
  id: 'systemupload-uber-document',
  url: '/system/upload-uber-document',
};

const LoginRoot = {
  id: 'login',
  url: '/login',
};

const CollectionForm = {
  id: 'systemficha-coleta',
  url: '/system/ficha-coleta',
};


export const navigationPages = {
  System: {
    Root: SystemRoot,
    Initial: SystemScan,
    Scan: SystemScan,
    RaSearch: SystemRaSearch,
    Crlv: SystemCrlv,
    UploadDocumentUber: SystemUberDocument,
    Sublocacao: SystemSublocacao,
    SublocacaoRelatorio: SystemSublocacaoRelatorio,
    UploadPaymentProof: SystemUploadPaymentProof,
    CollectionForm: CollectionForm,
  },
  Login: {
    Root: LoginRoot,
  }
};
